const envObj = {
  PORT: process.env.PORT || 3000,
  API_URL: process.env.API_URL || '',
  APP_URL: process.env.APP_URL,

  GTM_CONTAINER_ID: process.env.GTM_CONTAINER_ID || '',

  IS_DEV: true,
}

export default {...envObj}
